import { Avatar, Heading, VStack, Image, Box } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";

const greeting = "Hi, we're BonStudio!";
const bio1 = "A design and development studio";
const bio2 = "creating compelling user experiences.";

// Implement the UI for the LandingSection component according to the instructions.
// Use a combination of Avatar, Heading and VStack components.
const LandingSection = () => (
  <FullScreenSection
    justifyContent="center"
    alignItems="center"
    isDarkBackground
    backgroundColor="#ffffffff"
  >

    <Image src="BonStudio.png" alt="BonStudio Logo" height="300" mb={4} />

    <Avatar
      name="BonStudio"
      src="jk.jpg" />
    <Heading size="xl" color={"blackAlpha.900"}>{greeting}</Heading>
    <Box height={16} />
    <Heading size="3xl" color={"blackAlpha.900"}>{bio1}</Heading>
    <Heading size="2xl" color={"blackAlpha.900"}>{bio2}</Heading>


  </FullScreenSection>
);

export default LandingSection;
